import { useAuthStore } from '@/stores/authStore.js'

let sessionExpired = false

export function isSessionExpired() {
  return sessionExpired
}

export function markSessionExpired() {
  if (sessionExpired) return
  sessionExpired = true

  window.Sentry?.addBreadcrumb({
    category: 'auth',
    message: 'Session expired',
    level: 'warning',
  })

  // Defer redirect while a recording is in progress
  try {
    const authStore = useAuthStore()
    if (authStore.isRecordingActive) {
      authStore.sessionExpiredDuringRecording = true
      console.warn('Session expired during recording — redirect deferred')
      window.Sentry?.addBreadcrumb({
        category: 'auth.session',
        message: 'Session expired during recording — deferred redirect',
        level: 'warning',
      })
      return
    }
  } catch {
    // Pinia not yet installed (early startup) — fall through to redirect
  }

  console.warn('Session expired — redirecting to login')
  window.location.replace('/oauth2/authorization/auth0')
}

export function resetSessionGuard() {
  sessionExpired = false
}
